import React, { useEffect, useState } from 'react';

export default function InterestsCard({
  interest,
  view,
  setMealTypeList,
  setTopicsList,
  profileView
}) {
  const handleLikeClick = (term_id, view) => {
    if (view === 'meal-type') {
      setMealTypeList((prevState) => {
        const newState = [...prevState];
        const updatedItemIndex = newState.findIndex(
          (item) => item.term_id === term_id
        );

        newState[updatedItemIndex] = {
          ...newState[updatedItemIndex],
          selected: !newState[updatedItemIndex].selected
        };

        return newState;
      });
    } else {
      setTopicsList((prevState) => {
        const newState = [...prevState];
        const updatedItemIndex = newState.findIndex(
          (item) => item.term_id === term_id
        );

        newState[updatedItemIndex] = {
          ...newState[updatedItemIndex],
          selected: !newState[updatedItemIndex].selected
        };

        return newState;
      });
    }
  };

  return (
    <div className={`grid__interests grid__col-xs-6 grid__col-sm-4 grid__col-lg-3 ${profileView ? 'profile--view' : 'grid__col-xl-2'}`}>
      <div
        className={`tile tile--interests ${
          interest.selected ? ' tile--interests__saved' : ''
        }`}
        onClick={() => {
          handleLikeClick(interest.term_id, view);
        }}
      >
        <span className="tile__heart">
          <button className="btn btn--special">
            <i className="icon-heart"></i>
          </button>
        </span>
        <div className="tile__media">
          {interest.icon !== '' && (
            <span>
              <i className={`icon-${interest.icon}`}></i>
            </span>
          )}

          {interest.image_2x !== '' && (
            <img src={interest.image_2x} alt={interest.alt}></img>
          )}
        </div>
        <p
          className="tile__title"
          dangerouslySetInnerHTML={{ __html: interest.name }}
        ></p>
      </div>
    </div>
  );
}
